import { Base64 } from "js-base64";

export const cleanState = state => {
  delete state["ref"];
  return state;
};

export const getQueryString = state =>
  `_v=${Base64.encode(JSON.stringify(cleanState(state)))}`;
